import { cn } from '@/shared/utils/cn';

export const BlurredContainer = ({
  children,
  isBlurred,
  className = '',
}: {
  children: React.ReactNode;
  isBlurred: boolean;
  className?: string;
}) => {
  return (
    <div className={cn(isBlurred && 'blur-sm', className)}>{children}</div>
  );
};
